import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/shared/utils.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { ChangeImageComponent } from 'src/app/shared/change-image/change-image.component';
import { Factory } from '../factory.model';
import { User } from 'src/app/auth/user.model';

@Component({
    selector: 'app-factory-profile',
    templateUrl: './factory-profile.component.html',
    styleUrls: ['./factory-profile.component.scss'],
    standalone: false
})
export class FactoryProfileComponent implements OnInit {
  factoryForm!: FormGroup;
  userID: number;
  factoryData: Factory;
  srcResult: any;
  newImage: any;
  user: User;

  constructor(public dialog: MatDialog, private dataService: DataService,
              private authService: AuthService,
              private utils: UtilsService) {
    this.user = this.authService.getUserData();
    this.userID = this.user.id;
    this.factoryData = new Factory({});
    this.newImage = null;
   }

  ngOnInit(): void {
    this.utils.setTitle('Company Profile');
    if (this.user.type === this.utils.userTypes.Manufacturer) {
      this.utils.screenTitle.emit({firstTitle: 'Company Profile', firstRoute: '/factory-profile'});
    }

    this.dataService.get('company/RetrieveCompanyByUserId/' + this.userID).then((data) => {
      if (data.statusCode === 200) {
        this.factoryData = data.data;
        this.factoryForm = new FormGroup({
          company_name: new FormControl(this.factoryData.name, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
          company_history: new FormControl(this.factoryData.history, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
          company_mission: new FormControl(this.factoryData.mission, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
          company_vision: new FormControl(this.factoryData.vision, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
        });
      }
    });
    this.factoryForm = new FormGroup({
      company_name: new FormControl(null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      company_history: new FormControl(null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      company_mission: new FormControl(null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      company_vision: new FormControl(null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
    });
  }

  editImage() {
    this.dialog.open(ChangeImageComponent, {
      disableClose: true,
      width: '500px',
      data: {dialogParent: this, existingImage: this.newImage ? this.newImage : this.factoryData.logo, title: this.factoryData.logo ? null : 'Add New Image', resizeImage: true, aspectRatio: true}
    }).afterClosed().subscribe(result => {
      if (result) {
        this.newImage = result.croppedImage64;
      }
    });
  }

  updateFactoryData() {
    this.dataService.get('company/RetrieveCompanyByUserId/' + this.userID).then((data: any) => {
      if (data.statusCode === 200) {
        this.factoryData = data.data;
      }
    });
  }

  onImgError(event: any) {
    this.utils.theme$.subscribe((isDark: any) => {
      event.target.src  = isDark
        ? '../../../assets/images/products-dark.png'
        :'../../../assets/images/products-light.png';
    });
  }

  onSubmit() {
    if (this.factoryForm.valid) {
      const payload = {
        name: this.factoryForm.get('company_name')?.value,
        history: this.factoryForm.get('company_history')?.value,
        mission: this.factoryForm.get('company_mission')?.value,
        vision: this.factoryForm.get('company_vision')?.value,
        logo: this.newImage !== null ? this.newImage.slice(22, this.newImage.length) : null
      };
      this.dataService.put('company/UpdateCompanyProfile', payload).then((data: any) => {
        if (data.statusCode === 200) {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Success',
              type: 'Success',
              message: 'Company information updated successfully',
              buttonText: 'Ok'
            }
          });
        } else {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Something went wrong, please try again!',
              buttonText: 'Ok'
            }
          });
        }
      });
    } else {
      this.factoryForm.markAllAsTouched();
    }
  }

}
